import React from 'react';
import EmailEditor from 'react-email-editor';
import { reactLocalStorage } from 'reactjs-localstorage';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import withRouter from '../../../util/WithRouter';
import Const from '../../../util/Constants';
import FieldText from '../../common/FieldText';
import ApiUiController from '../../../controller/ApiUiController';
import ValidationController from '../../../controller/ValidationController';
import PropertyProjectTemplateAPI from '../../../api/PropertyProjectTemplateAPI';
import Util from '../../../util/Util';

class PropertyProjectTemplateUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.id);
    this.model = reactLocalStorage.getObject(Const.Model).property_project_temp;
    this.editorRef = React.createRef();
    this.state = { inApiCall: this.id !== 0, template: { id: 0, name: '' }, inValid: {} };
    this.base = this.props.match.path;
    this.base = this.base.substring(0, this.base.indexOf('/add-edit'));
  }

  componentDidMount() {
    if (this.id !== 0) { PropertyProjectTemplateAPI.get(this.id, this.onReceived, this.onFail); }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = template => {
    this.setState({ ...this.state, inApiCall: false, template: { ...template } });
  };

  onLoad = () => {
    const editorRef = this.editorRef;
    const state = this.state;
    setTimeout(() => { if (editorRef.current) editorRef.current.editor.loadDesign(state.template.design); }, 3000);
  };

  onValueChange = (field, text) => {
    const template = { ...this.state.template };
    template[field] = text;
    this.setState({ ...this.state, template: { ...template }, inValid: {} });
  };

  onSave = () => {
    const inValid = ValidationController.validate(this.model.fields, this.state.template);
    if (inValid === null) {
      this.editorRef.current.editor.exportHtml(data => {
        const template = {
          ...this.state.template,
          txt_body_json: JSON.stringify(data.design), txt_body_html: data.html
        };
        this.setState({ ...this.state, inApiCall: true });
        PropertyProjectTemplateAPI.save(template, this.onSaved, this.onFail);
      });
    } else { this.setState({ ...this.state, inValid: { ...inValid } }); }
  };
  onSaved = () => {
    Util.showNotification('Successful', 'Template successfully saved', 'success');
    this.props.navigate(this.base);
  };

  render() {
    return (
      <div className="sectionform pt-4">
        <div className="container-fluid form-cont">
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              <FieldText key="name" id="name"
                field={this.model.fields.name} value={this.state.template.name}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />
              <div className="col-md-12 pt-3">
                <EmailEditor ref={this.editorRef} onLoad={this.onLoad} />
              </div>
              <div className="col-md-12 text-center btnsend pt-4">
                <Button variant="success" onClick={this.onSave}>Save</Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(PropertyProjectTemplateUpdate);